import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI'];
export function TestimonialSlider() {
  const [index, setIndex] = useState(0);
  const reduce = useReducedMotion();
  const t = testimonials[index];
  const total = testimonials.length;
  const go = (dir: 1 | -1) => setIndex(i => (i + dir + total) % total);
  return <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,2.4fr)] lg:gap-[clamp(3rem,6vw,9rem)]" data-id="element-451" data-mp="3tbwcdgvwguit">
      <div className="flex flex-row items-end justify-between gap-6 lg:flex-col lg:items-start lg:justify-between" data-id="element-452" data-mp="b6041566ob50">
        <p className="t-numeral text-[clamp(1.4rem,1.1rem+1vw,2.4rem)] font-light text-charcoal" aria-live="polite" data-id="element-453" data-mp="73d8at6e662j">
          {ROMAN[index]} <span className="text-gold" data-id="element-454" data-mp="28x2pberfru3q">/</span> {ROMAN[total - 1]}
          <span className="sr-only" data-id="element-455" data-mp="28yxdd1y082c1">
            Testimonial {index + 1} of {total}
          </span>
        </p>
        <div className="flex gap-2" data-id="element-456" data-mp="2f10atebnbn86">
          <button type="button" onClick={() => go(-1)} aria-label="Previous testimonial" className="grid h-12 w-12 place-items-center border border-[#8F877F] text-charcoal transition-colors duration-150 hover:border-charcoal hover:bg-charcoal hover:text-white" data-id="element-457" data-mp="2f21zilll488d">
            <ArrowLeftIcon aria-hidden="true" strokeWidth={1.25} className="h-4 w-4" data-id="element-458" data-mp="2tpwrfzrrq8ke" />
          </button>
          <button type="button" onClick={() => go(1)} aria-label="Next testimonial" className="grid h-12 w-12 place-items-center border border-[#8F877F] text-charcoal transition-colors duration-150 hover:border-charcoal hover:bg-charcoal hover:text-white" data-id="element-459" data-mp="2xr883fsnzjgg">
            <ArrowRightIcon aria-hidden="true" strokeWidth={1.25} className="h-4 w-4" data-id="element-460" data-mp="37owh9ar0oti5" />
          </button>
        </div>
      </div>

      <div className="min-h-[clamp(18rem,26vw,24rem)]" data-id="element-461" data-mp="1dbn3v7vconum">
        <AnimatePresence mode="wait" initial={false} data-id="element-462" data-mp="1dc6m6powxe96">
          <motion.figure key={t.name} initial={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-463" data-mp="15ap591z9gilf">
            <blockquote className="max-w-[60ch] text-[clamp(1.3rem,1rem+1vw,2.15rem)] font-light leading-[1.45] text-charcoal" data-id="element-464" data-mp="1a9sdsweg96y5">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-8 flex flex-wrap items-center gap-x-4 gap-y-1" data-id="element-465" data-mp="1k8hl5v8pz905">
              <span className="t-label text-charcoal" data-id="element-466" data-mp="1k6eud8zqtbud">{t.name}</span>
              <span aria-hidden="true" className="h-px w-6 bg-gold" data-id="element-467" data-mp="1xz4h5fn3iksj" />
              <span className="text-graphite" data-id="element-468" data-mp="1t09u21i3ia2m">{t.location}</span>
              <span className="text-sm text-graphite" data-id="element-469" data-mp="27xtssqoef90c">· {t.focus}</span>
            </figcaption>
          </motion.figure>
        </AnimatePresence>
      </div>
    </div>;
}